// src/store/index.js
import Vue from 'vue'
import Vuex from 'vuex'
import preload from "@/store/modules/preload";
import createIndexedDBPlugin from './plugins/indexedDBPlugin'
import {dict} from "@/api/staff/staff";
import { clearAllStorage } from '@/untils/timeOutManager';
Vue.use(Vuex)

// 创建 store 实例
const store = new Vuex.Store({
    plugins: [
        createIndexedDBPlugin(),
    ],
    modules: {
        preload
    },
    state: {
        dict:null,
        permissions: [],
        userInfo: null,
        token: '',
    },
    mutations: {
        SET_LOGIN_DATA(state, payload) {
            state.permissions = payload.permissions || [];
            state.userInfo = payload.user || null;
            state.token = payload.token || '';
        },

        CLEAR_LOGIN_DATA(state) {
            state.permissions = [];
            state.userInfo = null;
            state.token = '';
        },
        SET_DICT_DATA(state, payload) {
            state.dict = payload;
        },
        CLEAR_DICT_DATA(state) {
            state.dict = null;
        },
        UPDATE_PERMISSIONS(state, permissions) {
            state.permissions = permissions || [];
        },
    },
    actions: {
        async updatePermissions({ commit }, permissions) {
            commit('UPDATE_PERMISSIONS', permissions);
        },
        async fetchDictData({ commit, state }) {
            try {
                // 如果已有数据则直接返回
                if (state.dict) return state.dict

                const res = await dict()
                // console.log(res,'resresres')
                if (res.code === 200) {
                    commit('SET_DICT_DATA', res.data)
                    return res.data
                }
                throw new Error(res.message || '字典数据加载失败')
            } catch (error) {
                console.error('字典数据加载失败:', error)
                throw error
            }
        },
        // 退出登录
        async logout({ commit }) {
            try {
                commit('CLEAR_LOGIN_DATA')
                commit('CLEAR_DICT_DATA')
                // 等待 Vuex 状态更新后再清理 IndexedDB
                await new Promise(resolve => setTimeout(resolve, 100))
                const db = await import('@/untils/db')
                await db.default.clearState()
                // console.log('✅ Logout completed, all data cleared')
            } catch (error) {
                console.error('❌ Logout error:', error)
            }
        },
		async logout({ commit }) {
		  try {
		    commit('CLEAR_LOGIN_DATA');
		    commit('CLEAR_DICT_DATA');
		    // 等待 Vuex 状态更新后再清理存储
		    await new Promise(resolve => setTimeout(resolve, 100));
		    const db = await import('@/untils/db');
		    await db.default.clearState();
		    
		    // 使用工具类清理存储
		    clearAllStorage();
		    
		    // console.log('✅ Logout completed, all data cleared');
		  } catch (error) {
		    // console.error('❌ Logout error:', error);
		  }
		},
        // 初始化应用
        async initApp({ dispatch, state }) {
            try {
                // 等待 IndexedDB 数据恢复
                await store.$dbReady

                // console.log('🔍 Current state after restore:', {
                //     token: state.token,
                //     userInfo: state.userInfo,
                //     permissions: state.permissions,
                //     preload: state.preload,
                //     dict: state.dict // 添加字典数据状态
                // })

                // 如果 token 存在，加载预加载数据
                if (state.token) {
                    await Promise.all([
                        dispatch('preload/loadAll'),
                        dispatch('fetchDictData')
                    ])
                }
            } catch (error) {
                console.error('❌ App initialization error:', error)
            }
        }
    },
    getters: {
        dict: state => state.dict || [],
        hasPermission: state => permission => {
            return (state.permissions || []).includes(permission)
        },
        hasAllPermissions: state => permissions => {
            if (!Array.isArray(permissions)) return false
            const userPermissions = state.permissions || []
            return permissions.every(p => userPermissions.includes(p))
        }
    },

})

export default store